import Ls from '@/services/ls'
import * as types from './mutation-types'

export const loadUsers = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/users`).then((response) => {
            commit(types.LOAD_USERS, response.data)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const loadRestaurantUsers = ({ commit, dispatch, state }, restaurant_id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/restaurant/${restaurant_id}/users`).then((response) => {
            commit(types.LOAD_USERS, response.data.data)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const loadUser = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`show/${id}/user`).then((response) => {
            commit(types.LOAD_USER, response.data)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const storeUser = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/user', data).then((response) => {
            resolve(response)
            commit(types.ADD_USER, response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

export const updateUser = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('update/' + data.id + '/user', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteUser = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.delete('delete/' + data + '/user').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const setVisibleUser= ({commit, dispatch, state}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('setVisible/' + data.id +'/user', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const findUserById = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/${id}/user`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const findUserConnected = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('/bootstrap').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const assignTeam = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        axios.post('users/assignTeam', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const storeUsersWithFile = ({ commit, dispatch, state }, data) => {
    let formData = new FormData();
    formData.append('file', data.file);
    formData.append('_method', 'POST');
    return new Promise((resolve, reject) => {
        window.axios.post(`users/import`, formData, {headers: {'Content-type': 'multipart/form-data'}}).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const setTableToUser = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('set/tables/to/users', data).then((response) => {
            commit(types.SET_USER, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const setPerimeterToUser = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('set/perimeters/to/user', data).then((response) => {
            commit(types.SET_USER, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const setRoomsToUser = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('set/rooms/to/user', data).then((response) => {
            commit(types.SET_USER, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const removeTableToUser = ({commit, dispatch, state}, {ids, user_id}) => {

    return new Promise((resolve, reject) => {
        window.axios.post('unset/tables/to/users',{ids, user_id}).then((response) => {
            commit(types.SET_USER, response.data.data)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}
export const removePerimeterToUser = ({commit, dispatch, state}, {ids, perimeter_id}) => {

    return new Promise((resolve, reject) => {
        window.axios.post('unset/perimeters/to/users',{ids, perimeter_id}).then((response) => {
            commit(types.SET_USER, response.data.data)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const removeRoomToUser = ({commit, dispatch, state}, {ids, room_id}) => {

    return new Promise((resolve, reject) => {
        window.axios.post('unset/rooms/to/user',{ids, room_id}).then((response) => {
            commit(types.SET_USER, response.data.data)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}